/**
 * Auth Modal Store
 * Global state for controlling the login modal from anywhere in the app
 */

import { create } from 'zustand'

interface AuthModalState {
  isOpen: boolean
  message?: string
  onSuccess?: () => void
  // Loading state for post-auth progress
  loadingMessage: string | null
  openLoginModal: (message?: string, onSuccess?: () => void) => void
  closeLoginModal: () => void
  setLoadingMessage: (message: string | null) => void
}

export const useAuthModalStore = create<AuthModalState>((set) => ({
  isOpen: false,
  message: undefined,
  onSuccess: undefined,
  loadingMessage: null,
  openLoginModal: (message, onSuccess) =>
    set({ isOpen: true, message, onSuccess }),
  closeLoginModal: () =>
    set({
      isOpen: false,
      message: undefined,
      onSuccess: undefined,
      loadingMessage: null,
    }),
  setLoadingMessage: (loadingMessage) => set({ loadingMessage }),
}))
